<template>
  <el-popover v-model="visible" placement="bottom" trigger="click" popper-class="custom-select">
    <span slot="reference" class="pointer ellipsis" >
      <span class="placeholder ellipsis" style="max-width: 180px">{{activedValue || placeholder}}</span>
      <i class="iconfont icon-jiantou-xuanze" style="color: #747A87;"></i>
    </span>
    <div class="options">
      <div class="searchInput">
        <el-input v-model="searchValue" :placeholder="$t('commodity.Components.Select.SearchFor')">
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
      </div>
      <p v-for="item in searchList" :key="item[field.key]" class="el-select-dropdown__item" :class="[activedKey === item[field.key] ? 'selected ' : '']" @click="selectOption(item)">{{item[field.value]}}</p>
    </div>
  </el-popover>
</template>

<script>
export default {
  model: {
    prop: 'activedKey',
    event: 'change'
  },
  props: {
    activedKey: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: 'Please Select'
    },
    options: {
      type: Array,
      default: () => []
    },
    field: {
      type: Object,
      default: () => ({ key: 'key', value: 'value' })
    }
  },
  data() {
    return {
      visible: false,
      activedOption: {},
      searchValue: undefined
    }
  },
  computed: {
    activedValue() {
      const option = this.options.find(item => item[this.field.key] === this.activedKey)
      return option ? option[this.field.value] : undefined
    },
    searchList() {
      if (!this.searchValue) {
        return this.options
      } else {
        const codeArr = []
        const nameArr = []
        this.options.forEach(e => {
          if (e.code.includes(this.searchValue.toUpperCase())) {
            codeArr.push(e)
          } else if (e.name.toUpperCase().includes(this.searchValue.toUpperCase())) {
            nameArr.push(e)
          } else if (this.searchValue.toUpperCase() === 'UK' && e.name.toUpperCase().includes('ENGLAND')) {
            nameArr.push(e)
          }
        })
        return [...codeArr, ...nameArr]
      }
    }
  },
  methods: {
    selectOption(item) {
      this.activedOption = item
      this.visible = false
      this.$emit('change', item[this.field.key])
    }
  }
}
</script>

<style lang="scss" scoped>
.options{
  max-height: 350px;
  overflow-y:auto;
}
.placeholder{
  vertical-align: text-bottom;
  display: inline-block;
  max-width: 200px;
  padding-right: 5px;
}
.searchInput {
  border-bottom: 1px solid #F5F7F7;
  .el-icon-search {
    font-size: 16px;
    line-height: 36px;
  }
  /deep/.el-input__inner{
    border: none !important;
  }
}
</style>
<style>
  .custom-select{
    padding: 5px 0!important;
  }
</style>
